import React from 'react'
import styles from "./style.module.css";
import {Images} from '../../assets/images/HomePage';
import DownloadButton from '../DownloadButton';
import { images } from '../../assets/images';

const Header = ({ width, heading, desc }) => {
  const { tenantScreenBg } = Images
  const { Apple, PlayStore } = images;
  return (
    <div className={styles.mainContainer}>
      <img className={styles.backgroundImage} src={tenantScreenBg} alt="" />
      <div className={styles.container}>
        <div style={{ maxWidth: width }} className={styles.header}>
          <h1 className={styles.heading}>
            {heading}
          </h1>
          <p className={styles.desc}>
            {desc}
          </p>
          <div className={styles.buttonContainer}>
            <DownloadButton icon={Apple} text="Download on App Store" />
            <DownloadButton icon={PlayStore} text="Download on Play Store" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
